import getEnv from "@/utils/environment/getEnvironment";
import axios, { AxiosResponse } from "axios";

export function getFiberAvailability(postalCode: string, houseNumber: string): Promise<AxiosResponse> {
  return axios.get(`${getEnv()?.apiBaseUrl}/v1/fiberAvailability?postalCode=${postalCode}&houseNumber=${houseNumber}`);
}
